import Api from "@/services/Index";

// Requester bilgisini getir - form açılmadan önce çağrılır
// PERMISSION: cateringform_requesterinfo
const getRequesterInfo = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/catering-forms/requester-info");
};

// Form options getir (Event, Account, Audience, Class, Location)
const getOptions = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/catering-forms/options");
};

// Form oluştur
// PERMISSION: cateringform_store
// Sadece is_leadership_team = true olan staff oluşturabilir
const store = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/catering-forms", data);
};

// Tüm formları listele (PO/Admin)
// PERMISSION: cateringform_index
const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/catering-forms", config);
};

// Kendi başvurularını listele
// PERMISSION: cateringform_myrequests
const getMyRequests = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/catering-forms/my-requests", config);
};

// Detay getir
// PERMISSION: cateringform_show
const get = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/catering-forms/" + id);
};

// PO — PPU doldur
// PERMISSION: cateringform_purchaseofficerfill
// Form status'ü waiting_po_review veya waiting_po_approval olmalı
// { menu_items: [{ id, ppu }] }
const purchaseOfficerFill = async (id, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put("/catering-forms/" + id + "/purchase-officer-fill", data);
};

// Requester — İncele & İmzala
// PERMISSION: cateringform_requestersign
// Form status'ü waiting_requester_review olmalı
// { budget_status, menu_items?: [{ id, quantity }] }
const requesterSign = async (id, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put("/catering-forms/" + id + "/requester-sign", data);
};

// Approval adımı güncelle (PO rank 1, Requester rank 2, CFO/President rank 3, PO receipt rank 4)
// { status: "approved" | "rejected" }
const updateStepStatus = async (stepId, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put("/approval/step/update/status/" + stepId, data);
};

// PO — Fatura yükle (çoklu dosya)
// PERMISSION: cateringform_uploadinvoice
// Form status'ü waiting_po_receipt olmalı
// invoices: File[] — mimes: pdf, jpg, jpeg, png | max: 10MB
const uploadInvoices = async (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/catering-forms/" + id + "/invoices", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};

// PO — Yanlış yüklenen faturayı sil
// PERMISSION: cateringform_deleteinvoice
const deleteInvoice = async (id, uuid) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete("/catering-forms/" + id + "/invoices/" + uuid);
};

// Excel export
// PERMISSION: cateringform_excelexport
const excelExport = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/catering-forms/excel-export", {
        ...config,
        responseType: "arraybuffer",
    });
};

// Audit PDF (approval steps dahil)
// PERMISSION: cateringform_auditpdf
const downloadAuditPdf = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/catering-forms/" + id + "/audit-pdf", {
        responseType: "arraybuffer",
    });
};

export default {
    getRequesterInfo,
    getOptions,
    store,
    getAll,
    getMyRequests,
    get,
    purchaseOfficerFill,
    requesterSign,
    updateStepStatus,
    uploadInvoices,
    deleteInvoice,
    excelExport,
    downloadAuditPdf,
};
